<div
  #modalElement
  role="document"
  class="ant-modal"
  (mousedown)="onMousedown()"
  [ngClass]="modalConfig.uiClassName!"
  [ngStyle]="modalConfig.uiStyle!"
  [style.width]="modalConfig?.uiWidth! | nzToCssUnit">
  <div class="ant-modal-content">
    <button *ngIf="modalConfig.uiClosable" ui-modal-close (click)="onCloseClick()"></button>
    <div class="ant-modal-body" [ngStyle]="modalConfig.uiBodyStyle!">
      <div class="ant-modal-confirm-body-wrapper">
        <div class="ant-modal-confirm-body">
          <i nz-icon [nzType]="modalConfig.uiIconType!"></i>
          <span class="ant-modal-confirm-title">
            <ng-container *nzStringTemplateOutlet="modalConfig.uiTitle">
              <span [innerHTML]="modalConfig.uiTitle"></span>
            </ng-container>
          </span>
          <div class="ant-modal-confirm-content">
            <ng-template cdkPortalOutlet></ng-template>
            <div *ngIf="isStringContent" [innerHTML]="modalConfig.uiContent"></div>
          </div>
        </div>
        <div class="ant-modal-confirm-btns">
          <button
            *ngIf="modalConfig.uiCancelText !== null"
            [attr.cdkFocusInitial]="modalConfig.uiAutofocus === 'cancel' || null"
            ui-button
            (click)="onCancel()"
            [uiLoading]="!!modalConfig.uiCancelLoading"
            [disabled]="modalConfig.uiCancelDisabled">
            {{ modalConfig.uiCancelText || locale.cancelText }}
          </button>
          <button
            *ngIf="modalConfig.uiOkText !== null"
            [attr.cdkFocusInitial]="modalConfig.uiAutofocus === 'ok' || null"
            ui-button
            [uiType]="modalConfig.uiOkType!"
            (click)="onOk()"
            [uiLoading]="!!modalConfig.uiOkLoading"
            [disabled]="modalConfig.uiOkDisabled"
            [uiDanger]="modalConfig.uiOkDanger">
            {{ modalConfig.uiOkText || locale.okText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
